import { Form, Input, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { mConstants } from "../../../../helper/constants";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { CustomerRequest } from "../entity/customer-request.model";
import { customerRequestService } from "../service/customer-request.service";
import CustomImage from "../../../../component/CustomImage";

function EditCustomerRequest() {
  let { customerRequestId } = useParams();
  const [customerRequest, setCustomerRequest] = useState<CustomerRequest>();

  const { Option } = Select;
  const navigate = useNavigate();

  useEffect(() => {
    if (customerRequestId) {
      customerRequestService
        .getCustomerRequest(customerRequestId)
        .then((customerRequest) => {
          setCustomerRequest(customerRequest);
        });
    }
  }, [customerRequestId]);

  const onFinish = async (_customerRequest: CustomerRequest) => {
    if (customerRequest) {
      customerRequest.status = _customerRequest.status;

      customerRequestService
        .updateCustomerRequest(customerRequest)
        .then((x) => {
          dialog.success(`Харилцагчийн хүсэлт шинэчлэгдлээ.`);

          navigate("/customer/requests");
        });
    }
  };
  console.log("customerRequest", customerRequest);
  return (
    <>
      <MPageHeader crumbs={["Харилцагчийн бүртгэлийн хүсэлт"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Промошн мэдээлэл</h6>
          </div>
          <div className="card-body">
            {customerRequest && (
              <fieldset
                disabled={
                  !helper.hasRoles([
                    "customer-request-full",
                    "customer-request-read-update",
                  ])
                }
              >
                <Form initialValues={customerRequest} onFinish={onFinish}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>UUID</label>
                        <Form.Item name="uuid" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Бүсийн дугаар</label>
                        <Form.Item
                          name={["route", "label"]}
                          rules={[{ required: true }]}
                        >
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {customerRequest.documentImagePaths ||
                  customerRequest.storeImagePaths ? (
                    <div className="row">
                      {customerRequest.storeImagePaths ? (
                        <div className="col-sm-12 col-md-6 mb-3">
                          <label>Дэлгүүрийн зураг</label>
                          <div className="d-flex flex-wrap">
                            {customerRequest.storeImagePaths?.map(
                              (route: any) => (
                                <div className="mr-3" key={route}>
                                  <CustomImage
                                    alt={
                                      mConstants.API_URL +
                                      mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                                      route
                                    }
                                    src={
                                      mConstants.API_URL +
                                      mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                                      route
                                    }
                                  />
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      {customerRequest.documentImagePaths ? (
                        <div className="col-sm-12 col-md-6 mb-3">
                          <label>Бичиг баримтын зураг</label>
                          <div className="d-flex flex-wrap">
                            {customerRequest.documentImagePaths?.map(
                              (route: any) => (
                                <div className="mr-3" key={route}>
                                  <CustomImage
                                    alt={
                                      mConstants.API_URL +
                                      mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                                      route
                                    }
                                    src={
                                      mConstants.API_URL +
                                      mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
                                      route
                                    }
                                  />
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Суваг</label>
                        <Form.Item
                          name={["channel", "label"]}
                          rules={[{ required: true }]}
                        >
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Улсын бүртгэл</label>
                        <Form.Item
                          name="customerType"
                          rules={[{ required: true }]}
                        >
                          <Select disabled={true}>
                            <Option value="CORPORATE">Байгууллага</Option>
                            <Option value="INDIVIDUAL">Хувь хүн</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Харилцагчийн албан ёсны нэр</label>
                        <Form.Item
                          name="commonName"
                          rules={[{ required: true }]}
                        >
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Харилцагчийн нэр</label>
                        <Form.Item name="name" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Регистрийн дугаар</label>
                        <Form.Item
                          name="registryNumber"
                          rules={[{ required: true }]}
                        >
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>НӨАТ төлөгч эсэх</label>
                        <Form.Item name="isVat" rules={[{ required: true }]}>
                          <Select disabled={true}>
                            <Option value={true}>НӨАТ төлөгч мөн</Option>
                            <Option value={false}>НӨАТ төлөгч биш</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Толгой байгууллагын нэр</label>
                        <Form.Item
                          name="holdingCompanyName"
                          rules={[{ required: true }]}
                        >
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Согтууруулах ундаа зарж болох</label>
                        <Form.Item
                          name="isAlcoholPermitted"
                          rules={[{ required: true }]}
                        >
                          <Select disabled={true}>
                            <Option value={true}>Тийм</Option>
                            <Option value={false}>Үгүй</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хот/Аймаг</label>
                        <Form.Item name="city" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Сум/Дүүрэг</label>
                        <Form.Item name="district" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Баг/Хороо</label>
                        <Form.Item name="khoroo" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хаяг</label>
                        <Form.Item name="address" rules={[{ required: true }]}>
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Утасны дугаар</label>
                        <Form.Item name="phoneNumber">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Супервайзорын утасны дугаар</label>
                        <Form.Item name="secondaryPhoneNumber">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Үүсгэсэн огноо</label>
                        <Input
                          readOnly={true}
                          className="form-control"
                          value={moment(customerRequest.createdDate).format(
                            mConstants.DATETIME_FORMAT
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Шинэчилсэн огноо</label>
                        <Input
                          readOnly={true}
                          className="form-control"
                          value={
                            customerRequest.updatedDate
                              ? moment(customerRequest.updatedDate).format(
                                  mConstants.DATETIME_FORMAT
                                )
                              : "Шинэчлээгүй"
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хүсэлтийн төрөл</label>
                        <Form.Item name="customerRequestType">
                          <Select disabled>
                            <Option value="ADD">
                              {helper.getCustomerRequestType("ADD")}
                            </Option>
                            <Option value="UPDATE">
                              {helper.getCustomerRequestType("UPDATE")}
                            </Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Үүсгэсэн ажилтан</label>
                        <Form.Item name="createdBy">
                          <Input disabled />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Хүсэлтийн төлөв</label>
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "Төлвийг сонгоно уу.",
                            },
                          ]}
                        >
                          <Select
                            disabled={
                              !helper.hasRoles([
                                "customer-request-full",
                                "customer-request-read-update",
                              ])
                            }
                          >
                            <Option value="NEW">Шинэ</Option>
                            <Option value="CANCELLED">Цуцласан</Option>
                            <Option value="APPROVED">Зөвшөөрсөн</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <Authorization
                    roles={[
                      "customer-request-full",
                      "customer-request-read-update",
                    ]}
                  >
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCustomerRequest;
